import { useState, useEffect } from "react";
import { getUserContractsByHierarchy } from "../actions";
import { formatParamsGet, resolveErrorMessage } from "../util";

const useGetUserContractsByHierarchy = ({ userId, contractId, types }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    contracts: [],
    commissionGenerated: 0,
  });

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        setLoading(true);
        setError(null);

        const params = formatParamsGet({
          contractId,
          types: types,
        });

        const response = await getUserContractsByHierarchy(userId, params);

        if (!response?.summary?.contracts?.length) {
          throw new Error(contractId || types?.length ? "app.contracts.NoFoundWithFilter" : "app.customer.contracts.empty");
        }

        setData({
          summary: response.summary,
          commissionGenerated: response.commissionGenerated,
        });
      } catch (err) {
        setError(resolveErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };

    fetchContracts();
  }, [contractId, types, userId]);

  return {
    summary: data.summary,
    commissionGenerated: data.commissionGenerated,
    loading,
    error,
  };
};

export default useGetUserContractsByHierarchy;
